import classNames from 'classnames';
import React, { ReactNode, useRef, useState } from 'react';
import Box, { BoxProps } from 'ui-box';
import { Heading, majorScale } from '.';

import { CSSTransition } from 'react-transition-group';

import styles from './TabSection.module.css';

export interface ITabSectionProps extends BoxProps<any> {
  defaultSelected?: number;
  sections: Array<{
    title: ReactNode;
    actions?: ReactNode;
    content?: ReactNode;
  }>;
  children?: never;
}

const TrueSection = ({ show, content }: any) => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <CSSTransition
      in={show}
      className={styles.content}
      timeout={200}
      unmountOnExit={true}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      nodeRef={ref}
    >
      <Box ref={ref}>{content}</Box>
    </CSSTransition>
  );
};

export const TabSection: React.FC<ITabSectionProps> = ({
  defaultSelected = 0,
  sections,
  ...props
}) => {
  const [selectedIndex, setSelectedIndex] = useState(
    Math.min(Math.max(defaultSelected, 0), sections.length - 1)
  );

  return (
    <Box {...props}>
      <Box
        display="flex"
        justifyContent="flex-start"
        className="border-bottom"
        position="relative"
        marginBottom={majorScale(2)}
        paddingBottom={majorScale(1)}
      >
        {sections.map((section, i) => (
          <Box
            key={i}
            className={classNames(
              styles.tabItem,
              selectedIndex === i && styles.selected
            )}
            onClick={() => setSelectedIndex(i)}
          >
            {typeof section.title === 'string' ? (
              <Heading size={400}>{section.title}</Heading>
            ) : (
              section.title
            )}
          </Box>
        ))}
        {sections[selectedIndex].actions && (
          <Box marginLeft="auto">{sections[selectedIndex].actions}</Box>
        )}
      </Box>
      <Box position="relative">
        {sections.map((section, i) => (
          <TrueSection
            key={i}
            show={selectedIndex === i}
            content={section.content}
          />
        ))}
      </Box>
    </Box>
  );
};
